import { addParam, addParams } from '@tv2/lib-core/querystring';

/**
 *
 * @param {{url: string}} image
 * @param {string} watermark If any, this is the watermark url.
 * @returns {string} Merged image string.
 */
export default function buildWatermarkImage(
  { url }: { url: string },
  watermark: string | undefined = undefined
): string {
  let imgSrc = addParam(url, 'auto', 'format');
  imgSrc = addParam(imgSrc, 'width', '188');

  if (watermark) {
    imgSrc = addParams(
      imgSrc,
      new Map([
        ['mark-scale', '13'],
        ['mark-pad', '0'],
        ['mark-x', '23'],
        ['mark-y', '13'],
        ['mark', watermark],
      ])
    );
  }

  return imgSrc || '';
}
